module.exports = "https://static.wanderu.com/ui-react/_next/static/media/de.7e82f4c7.svg";